import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { TableColumn } from 'lp-components'
import {
  PaginatedAndSortableTable,
  TableHeader,
  SearchInput,
  TableHeading,
  // DownloadTableButton,
} from 'components'
import {
  displayEin,
  einSorter,
  displayAttribute,
  useSearchParams,
  convertToSearchParams,
  formatUrl,
} from 'utils'
import { useHistory, Link } from 'react-router-dom'
import { Path } from 'config/portal'
import {
  PlanAgreementsTableHeaders,
  // ProductAgreementType,
} from 'config/products'
import { ServicesAgreementStatus } from 'config/automatic-rollovers'

const propTypes = {
  notificationsPlanAgreements: PropTypes.arrayOf(
    Types.notificationsPlanAgreementsSummary
  ).isRequired,
  noRowsFoundMessage: PropTypes.node,
  tableId: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    agreementStatus: PropTypes.arrayOf(PropTypes.string),
    initialInvestment: PropTypes.arrayOf(PropTypes.string),
    planSponsor: PropTypes.arrayOf(PropTypes.string),
    startLastUpdatedDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    endLastUpdatedDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }),
  // agreementsType: PropTypes.string.isRequired,
  // fieldMappings: PropTypes.arrayOf(PropTypes.object).isRequired,
  //noNotificationsPlanAgreements: PropTypes.bool.isRequired,
}

const defaultProps = {
  noRowsFoundMessage: null,
  filters: null,
}

function NotificationsPlanAgreementDetailsLinkARO({
  data: {
    serviceAgreementId,
    completeLegalPlanName,
    palPlanId,
    addendumStatus,
  },
}) {
  var agreementId =
    addendumStatus === ServicesAgreementStatus.COMPLETED ||
    addendumStatus === ServicesAgreementStatus.COMBINED_COMPLETED
      ? serviceAgreementId
      : palPlanId
  return (
    <td>
      <Link
        to={(location) => {
          return {
            pathname: formatUrl(`${Path.NOTIFICATIONS_HISTORY}/${agreementId}`),
            state: { search: location.search },
          }
        }}
        className="link-text"
        id="plan-name-link"
      >
        {completeLegalPlanName}
      </Link>
    </td>
  )
}

function NotificationsAgreementsTable({
  notificationsPlanAgreements,
  noRowsFoundMessage,
  tableId,
  filters,
  //noNotificationsPlanAgreements,
  // agreementsType,
  // fieldMappings,
}) {
  const history = useHistory()
  const searchParams = useSearchParams()

  const searchValue = searchParams.q ?? ''

  const updateSearchParams = (filters, searchValue) => {
    history.push({
      pathname: location.pathname,
      search: convertToSearchParams({
        ...filters,
        q: searchValue,
      }),
    })
  }
  // const disabled =
  //   agreementsType === ProductAgreementType.NOTIFICATIONS &&
  //   !servicesAgreements?.length
  // const showIcon = disabled
  return (
    <>
      <TableHeading title={PlanAgreementsTableHeaders.NOTIF}>
        {/* {!noServicesAgreements && (
          <DownloadTableButton
            data={servicesAgreements}
            fieldMappings={fieldMappings}
            fileName="Inspira Financial_Retirement Services_Notification Services Agreements"
            disabled={disabled}
            showIcon={showIcon}
          />
        )} */}
        <div className="input-container" id="services-agreements">
          <SearchInput
            type="search"
            aria-label="Search notification services agreement"
            placeholder={'Search plan sponsor, plan name, or EIN'}
            onChange={(e) => updateSearchParams(filters, e.target.value)}
            value={searchValue}
          />
        </div>
      </TableHeading>
      <PaginatedAndSortableTable
        data={notificationsPlanAgreements}
        initialAscending={false}
        initialColumn={'completeLegalPlanName'}
        parentScrollContainerSelector="#main-content"
        className="services-agreements-table"
        noRowsFoundMessage={noRowsFoundMessage}
        tableId={tableId}
      >
        <TableColumn
          label="Complete legal plan name"
          name={'completeLegalPlanName'}
          component={NotificationsPlanAgreementDetailsLinkARO}
          headerComponent={TableHeader}
        />
        <TableColumn
          label="Employer Identification Number (EIN)"
          name={'ein'}
          format={displayEin}
          sortFunc={einSorter}
          headerComponent={TableHeader}
        />
        <TableColumn
          label="Plan sponsor name"
          name={'planSponsorName'}
          headerComponent={TableHeader}
          format={displayAttribute}
        />
      </PaginatedAndSortableTable>
    </>
  )
}

NotificationsAgreementsTable.propTypes = propTypes
NotificationsAgreementsTable.defaultProps = defaultProps
export default NotificationsAgreementsTable
